import { render, staticRenderFns } from "./AlertsSettings.vue?vue&type=template&id=72521b86&scoped=true&"
import script from "./AlertsSettings.vue?vue&type=script&lang=js&"
export * from "./AlertsSettings.vue?vue&type=script&lang=js&"
import style0 from "./AlertsSettings.vue?vue&type=style&index=0&id=72521b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72521b86",
  null
  
)

export default component.exports